import { Injectable, inject } from "@angular/core";
import { SnackService } from "./snack-service.service";
import { AuthService } from "../../features/auth/services/auth.service";
import { TranslateUtils } from "../utils/translate.utils";

/**
 * Un 401 se DIT : « votre session a expirée, reconnectez-vous », avec un bouton vers la page de connexion
 * (16/10/2026, demande de Pierre). Avant, le snack affichait le message brut du serveur (« Unauthorized ») et
 * Justy « Erreur de communication » : l'utilisateur réessayait sans savoir quoi faire.
 *
 * Une rafale de 401 (un écran qui charge dix ressources) ne montre qu'UN message.
 */
@Injectable({ providedIn: "root" })
export class SessionExpireeService {
  private snack = inject(SnackService);
  private auth = inject(AuthService);
  private dernierAffichage = 0;
  static readonly RAFALE_MS = 5000;

  signaler(): void {
    const maintenant = Date.now();
    if (maintenant - this.dernierAffichage < SessionExpireeService.RAFALE_MS) return;
    this.dernierAffichage = maintenant;
    this.snack.errorWithAction(
      [TranslateUtils.translate("system.session_expiree")],
      TranslateUtils.translate("system.se_reconnecter"),
      () => {
        this.snack.dismiss();
        this.auth.logout();
      },
      "login",
    );
  }
}
